import { useSaleTypeForPlan } from "@/components/features/items/edit/_shared/ui/components/main/questions/sale-type-for-plan";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionSaleTypeForPlan = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { saleTypeForPlan } = viewModel;

	return useSaleTypeForPlan({ saleTypeForPlan, onSetViewModel });
};
